import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { AMB_PATH, DEFAULT_PROGRAM, faq } from "@/lib/ambassadors";
import { AmbConcept, AmbHero, AmbMissions } from "@/components/ambassadors/Intro";
import { AmbBenefits, AmbProfile, AmbSteps } from "@/components/ambassadors/Benefits";
import { AmbApply } from "@/components/ambassadors/ApplyForm";
import { AmbConditions, AmbFaq, AmbFinal } from "@/components/ambassadors/Faq";

export default function Ambassadors() {
  const { data } = useQuery({ queryKey: ["amb-program"], queryFn: () => api.get("/ambassadors/program").then((r) => r.data) });
  const program = { ...DEFAULT_PROGRAM, ...(data || {}) };
  useSeo({
    title: "Programme Ambassadeurs Ozentya : 2 produits offerts par mois | Ozentya",
    description: "Deviens ambassadeur Ozentya : partage tes soins cheveux afro sur les réseaux, reçois 2 produits offerts chaque mois et un code promo personnel de -20 % pour ta communauté.",
    path: AMB_PATH,
    image: "/editorial/coffret-vrais-produits-ozentya.webp",
    jsonLd: { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faq(program).filter((f) => !f.a.includes("[À")).map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
  });
  return (
    <main data-testid="ambassadors-page" className="bg-[#F6F0E7]">
      <AmbHero />
      <AmbConcept />
      <AmbMissions />
      <AmbBenefits code={program.example_code} />
      <AmbSteps />
      <AmbProfile />
      <AmbFaq program={program} />
      <AmbApply />
      <AmbConditions program={program} />
      <AmbFinal />
    </main>
  );
}
